module.exports = __webpack_public_path__ + "static/hosting-1810a94ee0ef9fb17462583dc4924f75.jpg";